import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { TagRoute, TagPathName } from '@/modules/ta/tag/tag.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${TagRoute.TAGS}`,
      name: TagPathName.TAGS,
      component: () => import(/* webpackChunkName: "tags-page" */ './pages/TagsPage.vue'),
    },
    {
      path: `/${TagRoute.TAGS}/new`,
      name: TagPathName.TAGFORM_NEW,
      component: () => import(/* webpackChunkName: "tag-form-page" */ './pages/TagFormPage.vue'),
      props: true,
    },
    {
      path: `/${TagRoute.TAGS}/:id`,
      name: TagPathName.TAGFORM,
      component: () => import(/* webpackChunkName: "tag-form-page" */ './pages/TagFormPage.vue'),
      props: true,
    },
  ],
  Module.TAG
);
